export default __webpack_public_path__ + "static/media/fieldbook_icon.f349b7df.png";